import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/section.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function Foundations() {
    return (
        <div className="section-container">
            <Header />
            <main className="section-content">
                <p className="section-intro-paragraph">Probably some stuff you should know beforehand</p>
                <div className="subsection-links">
                    <Link to="/foundations/python">Python & Libraries</Link>
                    <Link to="/foundations/linalg">Linear Algebra</Link>
                    <Link to="/foundations/calc">Calculus</Link>
                    <Link to="/foundations/probstat">Probability & Statistics</Link>
                    <Link to="/foundations/nn">Neural Networks & Regularization</Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default Foundations;